<template>
    <div class="wrapSQ">
        <!--轮播图-->
        <eazyswiper
            v-if="$route.query.type == 2"
            :key="'bbbbb'"
            :type="3"
        ></eazyswiper>
        <eazyswiper
            v-if="$route.query.type == 1"
            :key="'aaaaa'"
            :type="4"
        ></eazyswiper>
		<eazyswiper
		    v-if="$route.query.type == 9"
		    :key="'aaaaa'"
		    :type="9"
		></eazyswiper>
		<!-- 高考自考 -->
		<div v-if="type==9" class="gkzkContent" v-html="itemDataSix.description">
			
		</div>
        <div class="content flex-row">
			
            <!--社区教育-->
            <div class="item-box clearfix" v-if="type != 9">
                <div class="item-title flex-row">
                    <h2 > 
                        <!-- v-show="$route.query.type == 2" -->
                        {{
                            $route.query.type == 2
                                ? $store.state.navlist[4001]
                                : $store.state.navlist[3001]
                        }}
                    </h2>

                    <a
                        href="javascript:void(0);"
                        @click="
                            goDetail(
                                itemDataOne,
                                $route.query.type == 2
                                    ? $store.state.navlist[4000]
                                    : $store.state.navlist[3000],
                                $route.query.type == 2
                                    ? $store.state.navlist[4001]
                                    : $store.state.navlist[3001]
                            )
                        "
                        class="titleA"
                        >详情&gt;&gt;</a
                    >
                </div>
                <!--公用线-->
                <div
                    @click="
                        goDetail(
                            itemDataOne,
                            $route.query.type == 2
                                ? $store.state.navlist[4000]
                                : $store.state.navlist[3000],
                            $route.query.type == 2
                                ? $store.state.navlist[4001]
                                : $store.state.navlist[3001]
                        )
                    "
                    class="item-tw-img"
                >
                    <img :src="itemDataOne.image" :alt="itemDataOne.title" />
                </div>
                <div class="item-tw-text">
                    {{
                        itemDataOne.introduction &&
                        itemDataOne.introduction.length > 120
                            ? itemDataOne.introduction.substring(0, 120) + "..."
                            : itemDataOne.introduction
                    }}
                </div>

            </div>
            <!-- 招生报名 -->
            <div class="item-box clearfix" v-if="type != 9">
                <div class="item-title flex-row">
                    <h2>
                        {{
                            $route.query.type == 2
                                ? $store.state.navlist[4002]
                                : $store.state.navlist[3002]
                        }}
                    </h2>
                    <a
                        href="javascript:void(0);"
                        @click="
                            goDetail(
                                itemDataTwo,
                                $route.query.type == 2
                                    ? $store.state.navlist[4000]
                                    : $store.state.navlist[3000],
                                $route.query.type == 2
                                    ? $store.state.navlist[4002]
                                    : $store.state.navlist[3002]
                            )
                        "
                        class="titleA"
                        >详情&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            itemDataTwo,
                            $route.query.type == 2
                                ? $store.state.navlist[4000]
                                : $store.state.navlist[3000],
                            $route.query.type == 2
                                ? $store.state.navlist[4002]
                                : $store.state.navlist[3002]
                        )
                    "
                    class="item-tw-img"
                >
                    <img :src="itemDataTwo.image" :alt="itemDataTwo.title" />
                </div>
                <div class="item-tw-text">
                    {{
                        itemDataTwo.introduction &&
                        itemDataTwo.introduction.length > 120
                            ? itemDataTwo.introduction.substring(0, 120) + "..."
                            : itemDataTwo.introduction
                    }}
                </div>
            </div>
            <!-- 时间活动 -->
            <div class="item-box" v-if="type != 9">
                <div class="item-title flex-row">
                    <h2>
                        {{
                            $route.query.type == 2
                                ? $store.state.navlist[4003]
                                : $store.state.navlist[3003]
                        }}
                    </h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                $route.query.type == 2 ? 4003 : 3003,
                                $route.query.type == 2
                                    ? $store.state.navlist[4000]
                                    : $store.state.navlist[3000],
                                $route.query.type == 2
                                    ? $store.state.navlist[4003]
                                    : $store.state.navlist[3003]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $route.query.type == 2
                                ? $store.state.navlist[4000] +
                                      '<' +
                                      $store.state.navlist[4003]
                                : $store.state.navlist[3000] +
                                      '<' +
                                      $store.state.navlist[3003]
                        )
                    "
                    v-for="(item, index) in itemDataThree"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
            <!-- 学习服务支持 -->
            <div class="item-box"  v-if="type != 9">
                <div class="item-title flex-row">
                    <h2>
                        {{
                            $route.query.type == 2
                                ? $store.state.navlist[4004]
                                : $store.state.navlist[3004]
                        }}
                    </h2>
                    <a
                        href="javascript:void(0);"
                        class="titleA"
                        @click="
                            goList(
                                $route.query.type == 2 ? 4004 : 3004,
                                $route.query.type == 2
                                    ? $store.state.navlist[4000]
                                    : $store.state.navlist[3000],
                                $route.query.type == 2
                                    ? $store.state.navlist[4004]
                                    : $store.state.navlist[3004]
                            )
                        "
                        >更多&gt;&gt;</a
                    >
                </div>
                <div
                    @click="
                        goDetail(
                            item,
                            $route.query.type == 2
                                ? $store.state.navlist[4000] +
                                      '<' +
                                      $store.state.navlist[4004]
                                : $store.state.navlist[3000] +
                                      '<' +
                                      $store.state.navlist[3004]
                        )
                    "
                    v-for="(item, index) in itemDataFour"
                    :key="index"
                    class="zixun-item flex-row"
                >
                    <span class="zixun-title">{{ item.title }}</span>
                    <span class="zixun-item-time">{{
                        item.creaTime.time | dateFormat
                    }}</span>
                </div>
            </div>
			<!-- 开放大学成果展示 -->
			<div class="item-box"  v-if="type==1">
			    <div class="item-title flex-row">
			        <h2>
			            {{
			                 $store.state.navlist[3005]
			            }}
			        </h2>
			        <a
			            href="javascript:void(0);"
			            class="titleA"
			            @click="
			                goList(3005,$store.state.navlist[3000],$store.state.navlist[3005])
			            "
			            >更多&gt;&gt;</a
			        >
			    </div>
			    <div
			        @click="
			            goDetail(
			                item,
			              $store.state.navlist[3000] +
			                          '<' +
			                          $store.state.navlist[3005]
			            )
			        "
			        v-for="(item, index) in itemDataSeven"
			        :key="index"
			        class="zixun-item flex-row"
			    >
			        <span class="zixun-title">{{ item.title }}</span>
			        <span class="zixun-item-time">{{
			            item.creaTime.time | dateFormat
			        }}</span>
			    </div>
			</div>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "lnjy",
    data() {
        return {
            itemDataOne: {},
            itemDataTwo: {},
            itemDataThree: [],
            itemDataFour: [],
            type: 1,
			itemDataSix: {},//高考自考简介
			itemDataSeven: [],//开放大学成果展示
        };
    },
    created() {
        this.getZkgkData()
        this.getZixunData(3005);
        if (this.$route.query.type == 2) {

            this.type = 2;
            // 奥鹏教育概述
            this.getZixunData(4001);
            // 招生报名
            this.getZixunData(4002);
            // 奥鹏教务教学
            this.getZixunData(4003);
            // 学习服务支持
            this.getZixunData(4004);
        } else if(this.$route.query.type == 1){
 
            this.type = 1;  
            // 开放教育概述
            this.getZixunData(3001);
            // 招生报名
            this.getZixunData(3002);
            // 教务教学
            this.getZixunData(3003);
            // 学习服务支持
            this.getZixunData(3004);
			 // 成果展示
	
        }else{
            this.type = 9;
        }
        
    },
    methods: {
		// 获取高考自考简介
		getZkgkData(){
				this.$ajax({
					method: "post",
					url: "homePage/getInformation",
					data: {
						  navigationId: 5001,
                            curren: 1
					},
					success: res => {
						if (res.code == 200) {
                            this.itemDataSix = res.message.records[0];
						}
					},
					error: res => {
						console.log(res);
					}
				});
			
		},
        goList(navId, titleOne, titleTwo) {
            this.$router.push({
                name: "articalList",
                query: {
                    id: navId,
                    t1: titleOne,
                    t2: titleTwo
                }
            });
        },
        goDetail(item, title, titleTwo = "") {
            this.$router.push({
                name: "artDetail",
                query: {
                    id: item.id,
                    t1: title,
                    t2: titleTwo ? titleTwo : ""
                }
            });
        },
        getZixunData(navId, page = 1) {
            this.$ajax({
                method: "post",
                url: "homePage/getInformation",
                data: {
                    navigationId: navId,
                    curren: page
                },
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 6
                            ? (res.message.records.length = 6)
                            : res.message.records;
                        switch (navId) {
                            case 4001:
                                this.itemDataOne = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
								// 5001 高考自考简历
							case 5001:
							    this.itemDataSix = res.message.records[0]   
							        ? res.message.records[0]
                                    : {};
							    break;
                            case 4002:
                                this.itemDataTwo = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
                            case 4003:
                                this.itemDataThree = res.message.records;
                                break;
                            case 4004:
                                this.itemDataFour = res.message.records;
                                break;
                            case 3001:
                                this.itemDataOne = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
                            case 3002:
                                this.itemDataTwo = res.message.records[0]
                                    ? res.message.records[0]
                                    : {};
                                break;
                            case 3003:
                                this.itemDataThree = res.message.records;
                                break;
                            case 3004:
                                this.itemDataFour = res.message.records;
                                break;
                            case 3005:
                                this.itemDataSeven = res.message.records;
                                console.log(this.itemDataSeven)
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
        },
        updatedData() {
            this.itemDataOne = {};
            this.itemDataTwo = {};
            this.itemDataThree = [];
            this.itemDataFour = [];
            if (this.$route.query.type == 2) {
                // 奥鹏教育概述
                this.getZixunData(4001);
                // 招生报名
                this.getZixunData(4002);
                // 奥鹏教务教学
                this.getZixunData(4003);
                // 学习服务支持
                this.getZixunData(4004);
            } else {
                // 开放教育概述
                this.getZixunData(3001);
                // 招生报名
                this.getZixunData(3002);
                // 教务教学
                this.getZixunData(3003);
                // 学习服务支持
                this.getZixunData(3004);
            }
            // this.getZixunData(5001)
        }
    },
    watch: {
        "$route.query.type": function(nval) {
            this.type = nval;
            this.updatedData();
        }
    }
};
</script>
<style scoped="scoped" lang="scss">
.gkzkContent{
	min-height: 300px;
}
.content {
    width: 1000px;
    margin: 0 auto;
    min-height: 500px;
    margin-top: 40px;
    align-items: flex-start;
    align-content: flex-start;
}
/* 图文盒子 */
.item-box:nth-child(odd) {
    margin-right: 60px;
}
.item-box {
    width: 470px;
    margin-bottom: 50px;
    margin-right: 0;
    border: 0;
    display: inline-block;
    position: relative;
    .item-title {
        color: #595959;
        height: 40px;
        padding: 0;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        margin-bottom: 10px;
        h2 {
            position: relative;
            height: 20px;
            line-height: 20px;
            padding: 10px 0;
            border-bottom: 2px solid #6ac0e8;
            display: inline-block;
            z-index: 1;
            font-size: 18px;
            font-weight: bold;
        }
        a {
            line-height: 40px;
            font-size: 16px;
            color: #6ac0e8;
        }
    }
    // 图文信息
    .item-tw-img {
        width: 158px;
        height: 185px;
        float: left;
        margin: 5px 0;
        border: 1px solid #ddd;
        box-sizing: border-box;
        transition: all ease 0.3s;
        overflow: hidden;
        img {
            width: 100%;
            min-height: 100%;
            overflow: hidden;
        }
    }
    .item-tw-img:hover {
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    }
    .item-tw-text {
        width: 300px;
        height: 185px;
        float: right;
        margin: 5px 0;
        overflow: hidden;
        line-height: 23px;
    }
    // 信息
    .zixun-item {
        justify-content: space-between;
        cursor: pointer;
        .zixun-title {
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 5px 0;
            flex: 1;
            overflow: hidden;
        }
        .zixun-item-time {
            float: right;
            font-size: 14px;
            color: #999;
        }
    }
    .zixun-item:hover > .zixun-item-time {
        color: #333 !important;
    }
    .zixun-item:hover > .zixun-title {
        color: #333 !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/xljy/xljy.vue